<template>
  <div class="email-phone-input">
    <InputNew
      :value="displayValue"
      :placeholder="placeholder"
      :label="label"
      :error="error"
      :error-message="errorMessage"
      color="gray"
      type="text"
      @input="handleInput"
      @blur="$emit('blur')"
      @focus="$emit('focus')"
    />
  </div>
</template>

<script>
import InputNew from '../form/InputNew.vue'

export default {
  name: 'EmailOrPhoneInput',
  components: {
    InputNew,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
    error: {
      type: Boolean,
      required: false,
      default: false,
    },
    errorMessage: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      internalValue: this.value,
    }
  },
  computed: {
    inputType() {
      if (!this.internalValue) return null
      return this.isEmail(this.internalValue) ? 'email' : 'phone'
    },
    displayValue() {
      if (!this.internalValue) return ''

      if (this.inputType === 'phone') {
        return this.formatPhoneNumber(this.internalValue)
      }

      // For email, just return the value without any + prefix
      return this.internalValue.startsWith('+') ? this.internalValue.substring(1) : this.internalValue
    },
  },
  watch: {
    value(newVal) {
      if (newVal !== this.internalValue) {
        this.internalValue = newVal
      }
    },
  },
  methods: {
    isEmail(value) {
      return /[^0-9+]/.test(value)
    },

    handleInput(val) {
      let inputValue = val

      // If switching from phone to email, remove the + prefix
      if (this.inputType === 'email' && inputValue.startsWith('+')) {
        inputValue = inputValue.substring(1)
      }

      this.internalValue = inputValue
      this.$emit('input', this.displayValue)
    },

    formatPhoneNumber(value) {
      // Remove all non-digit characters except +
      let inputValue = value.replace(/[^\d+]/g, '')

      // If no digits, return empty
      if (!inputValue.replace(/\D/g, '')) {
        return ''
      }

      // If already has + at the start
      if (inputValue.startsWith('+')) {
        let digits = inputValue.substring(1)

        // Convert 8 to 7 for Russian numbers if it starts with 8
        if (digits.startsWith('8')) {
          return '+7' + digits.substring(1)
        }

        return inputValue
      }

      // Handle numbers without a + prefix
      let digits = inputValue

      // If starts with 8, replace with +7 (Russian number)
      if (digits.startsWith('8')) {
        return '+7' + digits.substring(1)
      }
      // If starts with 7, add + (Russian number)
      else if (digits.startsWith('7')) {
        return '+' + digits
      }
      // For other numbers, just add +
      else {
        return '+' + digits
      }
    },
  },
}
</script>

<style scoped>
.email-phone-input {
  position: relative;
  display: block;
}
</style>
